import { useState, useRef, useEffect } from "react"
import './notifications.css'
import {  getMyNotifications } from "../../services/Trainer/trainer"

const NotificationsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
const [notifications , setNotifications] = useState();

const fetchData = async () => {
    const data = await getMyNotifications(); 
    if (data) {
      console.log("admin profile data >>>", data);
      setNotifications(data?.notifications);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  // Helper function to get notification icon based on message type
  const getNotificationIcon = (message) => {
    if (message.includes("reacted") || message.includes("liked")) {
      return (
        <div className="notification-icon like-icon">
          <i className="bi bi-hand-thumbs-up-fill text-primary"></i>
        </div>
      )
    } else if (message.includes("completed") || message.includes("updated")) {
      return (
        <div className="notification-icon completed-icon">
          <i className="bi bi-check-circle-fill text-success"></i>
        </div>
      )
    } else {
      return (
        <div className="notification-icon default-icon">
          <i className="bi bi-bell-fill text-info"></i>
        </div>
      )
    }
  }

  // Helper function to format time
  const formatTime = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
  }

  return (
    <div className="dropdown custom-notifications" ref={dropdownRef}>
      <button
        className="btn btn-light notification-btn position-relative"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
      >
        <i className="bi bi-bell"></i>
        {/* {notifications && notifications?.length > 0 && (
          <span className="notification-badge position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {notifications.length || 1}
          </span>
        )} */}
      </button>

      <div
        className={`dropdown-menu dropdown-menu-end ${isOpen ? "show" : ""}`}
        style={{ width: "400px", maxHeight: "550px", overflowY: "auto" }}
      >
        <div className="dropdown-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0">Notifications</h6>
          {/* {notifications && notifications?.length > 0 && (
            <small className="text-muted">{notifications.length} new</small>
          )} */}
        </div>

        <div className="dropdown-divider"></div>

        {notifications && notifications?.length > 0 ? (
          <div className="notification-list">
            {notifications.map((item) => (
              <div key={item._id} className="dropdown-item-text notification-item p-3 border-bottom">
                <div className="d-flex align-items-start">
                  <div className="me-3">{getNotificationIcon(item.message)}</div>

                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start mb-1">
                      <div className="notification-header">
                        <small className="text-muted">{formatTime(item.createdAt)}</small>
                        {/* <span className="online-indicator ms-2">
                          <i className="bi bi-circle-fill text-success" style={{ fontSize: "0.5rem" }}></i>
                        </span> */}
                      </div>
                      <small className="text-muted">{formatDate(item.createdAt)}</small>
                    </div>

                    <div className="notification-text">
                      <span className="fw-semibold me-1">{item.user?.fullName || "Unknown"}</span>
                      <span className="text-muted">{item.message.replace(item.user?.fullName, "").trim()}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="dropdown-item-text text-center py-4">
            <i className="bi bi-bell-slash text-muted" style={{ fontSize: "2rem" }}></i>
            <p className="text-muted mt-2 mb-0">No notifications yet</p>
          </div>
        )}

        {/* {dashboardData?.notifications && notifications?.length > 0 && (
          <>
            <div className="dropdown-divider"></div>
            <div className="dropdown-item text-center">
              <button className="btn btn-link btn-sm text-decoration-none">View all notifications</button>
            </div>
          </>
        )} */}
      </div>
    </div>
  )
}

export default NotificationsDropdown
